import { createContext, useContext, useMemo } from 'react';

import type { AbstractLogger } from '.';
import { ConsoleLogger } from '.';

export const LoggerContext = createContext<AbstractLogger>(new ConsoleLogger('undefined'));

function useLoggerContext() {
  return useContext(LoggerContext);
}

export function useLogger() {
  return useLoggerContext();
}

/**
 * @deprecated Meant to be used only by framework provider. Use `ReactLogger.Provider` instead.
 */
export function RootProvider(props: React.PropsWithChildren<{ logger: AbstractLogger }>) {
  return <LoggerContext.Provider value={props.logger}>{props.children}</LoggerContext.Provider>;
}

export function Provider(props: React.PropsWithChildren<{ name: string }>) {
  const logger = useLogger();
  const childLogger = useMemo(() => logger.child(props.name), [logger, props.name]);

  return <LoggerContext.Provider value={childLogger}>{props.children}</LoggerContext.Provider>;
}
